import styled, { css } from 'styled-components';

import Overlay from 'ggApp/shared/common/Overlay';

import Content from './Content';

const Wrap = styled(Overlay)`
    height: 100vh;
    z-index: 6;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    cursor: pointer;
`;

const Container = styled(Content)`
    min-height: 100%;
    background: ${({ theme }) => theme.colors.Background};
    transition: all 0.2s cubic-bezier(0.4, 0, 1, 1);
    transform: translateX(-100%);
    ${({ shouldShowMenu }) => shouldShowMenu
        && css`
            transition: all 0.2s cubic-bezier(0, 0, 0.2, 1);
            transform: translateX(0%);
        `};
`;

export {
    Wrap,
    Container,
};
